import React from 'react'
import { getTheme } from '../../themes'
import S from './styled'
import Logout from './logout'

const theme = getTheme()

const Header = () => (
  <S.Header>
    <S.Title>{theme.title}</S.Title>
    <S.Logo><img src={theme.logoFull} alt="Cuciniale"/></S.Logo>
    <Logout />
  </S.Header>
)

export default Header
